import React, { useState, useContext } from 'react'
import Spinner from '../components/Spinner/Spinner'
const SpinnerContext = React.createContext()

const SpinnerContextProvider = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <SpinnerContext.Provider value={{ isLoading, setIsLoading }}>
      <Spinner />
      {props.children}
    </SpinnerContext.Provider>
  )
}
export const useSpinnerContext = () => useContext(SpinnerContext)
export default SpinnerContextProvider
